import React from 'react';
import { Hero } from './Hero';
import { PainSection } from './PainSection';
import { ProductReveal } from './ProductReveal';
import { ObjectionsSection } from './ObjectionsSection';
import { WhatYouGet } from './WhatYouGet';
import { PriceClose } from './PriceClose';
export function SalesPage() {
  return <main className="min-h-screen bg-[#FFFBF5] overflow-x-hidden" data-id="element-143">
      <Hero data-id="element-144" />
      <PainSection data-id="element-145" />
      <ProductReveal data-id="element-146" />
      <ObjectionsSection data-id="element-147" />
      <WhatYouGet data-id="element-148" />
      <PriceClose data-id="element-149" />

      <footer className="bg-[#2D3A4A] text-[#FFFBF5]/40 py-8 text-center text-sm" data-id="element-150">
        <p data-id="element-151">
          © {new Date().getFullYear()} Agenda Anti-Pantallas. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}